import { CellCoordsObj, CellRangeObj, CellSelection } from '../../../../../common/table/TableTypes';
import { getCellRangeFromSelection, getCellSelectionFromRange } from '../tableCellRangeUtils';

type ForEachCellInSelectionArgs = {
    cellSelection: CellSelection;
    callback: (cell: CellCoordsObj) => void;
};

type ForEachCellInRangeArgs = {
    cellRange: CellRangeObj;
    callback: (cell: CellCoordsObj) => void;
};

/**
 * Iterates each cell inside a rectangular selection, inclusive of the provided bounds.
 */
export const forEachCellInSelection = ({ cellSelection, callback }: ForEachCellInSelectionArgs): void => {
    const cellRange = getCellRangeFromSelection(cellSelection);
    const startRow = Math.min(cellRange.from.row, cellRange.to.row);
    const endRow = Math.max(cellRange.from.row, cellRange.to.row);
    const startCol = Math.min(cellRange.from.col, cellRange.to.col);
    const endCol = Math.max(cellRange.from.col, cellRange.to.col);

    for (let row = startRow; row <= endRow; row++) {
        for (let col = startCol; col <= endCol; col++) {
            callback({ row, col });
        }
    }
};

/**
 * Iterates each cell inside a rectangular range, inclusive of the provided bounds.
 */
export const forEachCellInRange = ({ cellRange, callback }: ForEachCellInRangeArgs): void =>
    forEachCellInSelection({
        cellSelection: getCellSelectionFromRange(cellRange),
        callback,
    });
